import React, { useEffect, useState } from 'react'
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom'
import useAuthStore from '../stores/authStore';
import { getAllNews } from '../api';
import { AiOutlineHome, AiOutlineBell, AiOutlineLogout, AiOutlineProfile } from 'react-icons/ai';

function Header() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [hasNew, setHasNew] = useState(false);

  useEffect(() => {
    async function checkNews() {
      const news = await getAllNews();
      const lastSeen = localStorage.getItem('lastSeenNewsId');
      if (news && news.length > 0 && news[0]._id !== lastSeen) {
        setHasNew(true);
      } else {
        setHasNew(false);
      }
    }
    checkNews();
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === '/news') {
      setHasNew(false);
    }
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };
  if (user && !user.isAdmin && window.innerWidth <= 600) return null;
  return (
    <div className='Header'>
        <div className="Header__container">
            <div className="logo">
                ФизМат
            </div>

            <div className="menu">
                <ul>
                    <li><NavLink to="/home">Расписание</NavLink></li>
                    <li><NavLink to="/attendance">Посещаемость</NavLink></li>
                    <li style={{ position: 'relative' }}>
                      <NavLink to="/news">Новости</NavLink>
                      {hasNew && <span style={{ position: 'absolute', top: -7, right: -18, background: '#e74c3c', color: '#fff', borderRadius: '50%', width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>1</span>}
                    </li>
                </ul>
            </div>
            <button onClick={handleLogout} style={{ marginLeft: 'auto', background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontWeight: 500, fontSize: 15, cursor: 'pointer' }}>Выйти</button>
        </div>
    </div>
  )
}

export function BottomNavBar() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [hasNew, setHasNew] = useState(false);

  useEffect(() => {
    async function checkNews() {
      const news = await getAllNews();
      const lastSeen = localStorage.getItem('lastSeenNewsId');
      if (news && news.length > 0 && news[0]._id !== lastSeen) {
        setHasNew(true);
      } else {
        setHasNew(false);
      }
    }
    checkNews();
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === '/news') {
      setHasNew(false);
    }
  }, [location.pathname]);

  if (!user || user.isAdmin || window.innerWidth > 600) return null;
  return (
    <nav style={{
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      height: 60,
      background: '#fff',
      borderTop: '1px solid #ece9f7',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 100,
      boxShadow: '0 -2px 8px #ece9f7',
    }}>
      <button onClick={() => navigate('/home')} style={{ background: 'none', border: 'none', color: '#4c20bb', fontSize: 28, display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
        <AiOutlineHome />
        <span style={{ fontSize: 12, marginTop: 2 }}>Домой</span>
      </button>
      <button onClick={() => navigate('/attendance')} style={{ background: 'none', border: 'none', color: '#4c20bb', fontSize: 28, display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
        <AiOutlineProfile />
        <span style={{ fontSize: 12, marginTop: 2 }}>Посещаемость</span>
      </button>
      <button onClick={() => navigate('/news')} style={{ background: 'none', border: 'none', color: '#4c20bb', fontSize: 28, display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', position: 'relative' }}>
        <AiOutlineBell />
        {hasNew && <span style={{ position: 'absolute', top: 2, right: 10, background: '#e74c3c', color: '#fff', borderRadius: '50%', width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 12 }}>1</span>}
        <span style={{ fontSize: 12, marginTop: 2 }}>Новости</span>
      </button>
      <button onClick={() => { logout(); navigate('/'); }} style={{ background: 'none', border: 'none', color: '#e74c3c', fontSize: 28, display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
        <AiOutlineLogout />
        <span style={{ fontSize: 12, marginTop: 2 }}>Выйти</span>
      </button>
    </nav>
  );
}

export default Header